import './style.scss';
import { Box } from "@mui/material";
import AppBar from "../../components/AppBar";
import Content from "../../components/Content";
import NavigationContextProvider from "../../contexts/NavigationContext";
import PartnerPmsContextProvider from '../../contexts/PartnerPmsContext';
import ReportPreviewContextProvider from '../../contexts/ReportPreviewContext';

const Admin = () => {
    return (
        <>
            <NavigationContextProvider>
                <Box component="div" className="grid-admin">
                    <AppBar />
                    
                    <PartnerPmsContextProvider>
                        <ReportPreviewContextProvider>
                            <Content />
                        </ReportPreviewContextProvider>
                    </PartnerPmsContextProvider>
                </Box>
            </NavigationContextProvider>
        </>
    );
}


export default Admin;